import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=2e478b74&"
import script from "./NotesView.vue?vue&type=script&lang=ts&"
export * from "./NotesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports